var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequisitionCompleted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Requisition_Completed"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Requisition_Completed",
    "data-name": "Requisition Completed",
    clipPath: "url(#clip-Requisition_Completed)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_593",
    "data-name": "Ellipse 593",
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#0072ce",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20212",
    "data-name": "Path 20212",
    d: "M73.391,78.028l2.032,2.206,4.894-4.95",
    transform: "translate(-66.854 -67.759)",
    fill: "none",
    stroke: "#0072ce",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequisitionCompleted);
export default __webpack_public_path__ + "static/media/RequisitionCompleted.e6fcf9630e0db4290b696279db6f4290.svg";
export { ForwardRef as ReactComponent };